import { render, staticRenderFns } from "./studioList.vue?vue&type=template&id=71c2e6de"
import script from "./studioList.vue?vue&type=script&lang=js"
export * from "./studioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports